import actionTypes from '../constants/action-types';

const selectedElement = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_ELEMENT: {
      return action.payload.elementId;
    }

    case actionTypes.CONNECT_MAPPED_HTML:
    case actionTypes.DELETE_ELEMENT: {
      return null;
    }

    default:
      return state;
  }
};

export default selectedElement;
